export const IpAddresses = {
    flaskUrl: "http://192.168.1.6:5000",
    // flaskUrl: "https://api.surgeparty.com",
    clientId: "ac475d6bec40429a96dc70a3110af05e",
    redirectUri: "http://localhost:3000/playlist-page",   
    Django_Api_IP: "django-env.eba-tcxibyf2.us-west-2.elasticbeanstalk.com",
    Django_Api_Port: '80',
}